import React, { useEffect, useState } from 'react';
import ApplicationLayout from '../../../layouts/ApplicationLayout';
import { Helmet } from 'react-helmet';
import InputAssetSearch from '../../includes/ui/InputAssetSearch';
import TapIcon from '../../../services/TapIcon';
import AssetMiniDetail from '../../includes/ui/AssetMiniDetail';
import HttpAPICall from '../../../services/HttpAPICall';
import { useSelector } from 'react-redux';
import Loader from '../../../components/ui/Loader/Loader';
import { toast } from 'react-toastify';
import GroupCard from '../../group/GroupCard';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';

const ChangeAssetMatrixs = ({ props, history }) => {

    const access_token          = useSelector(state => state.auth.access_token);
    const location              = useLocation();
    const selectedGroup         = location.state?.selectedGroup;
    const [searchedAssetCounterLog, setSearchedAssetCounterLog]             = useState([]);
    const [saveFormSubmitting, setSaveFormSubmitting]                       = useState(false);
    const [assetDetails, setAssetDetails]                                   = useState(null);
    const [newAssetMatrixId, setNewAssetMatrixId]                           = useState('');
    const [loadingDetails, setLoadingDetails]                               = useState(false);

    const tapSelectChange = (selectedOptions) => {
        if (!selectedOptions) {
            setSearchedAssetCounterLog([]);
            setAssetDetails(null);
            return;
        }
        const optionsArray = Array.isArray(selectedOptions) ? selectedOptions : [selectedOptions];
        setSearchedAssetCounterLog(optionsArray);
        if (optionsArray.length > 0) {
            fetchAssetDetails(optionsArray[0].value);
        }
    };

    const fetchAssetDetails = (assetId) => {
        setLoadingDetails(true);
        
        const params = {
            master_id: selectedGroup?.master_id ,
            asset_id: assetId,
        };

        HttpAPICall.withAthorization('GET', process.env.REACT_APP_SERVER_PATH + '/backoffice/group/asset/detail',
            access_token, params, {}, (resp) => {
                setAssetDetails(resp.data);
                setLoadingDetails(false);
            }, (error) => {
                toast.error(error, { position: toast.POSITION.TOP_CENTER })
                setLoadingDetails(false);
            }
        );
    };

    const handleClose = () => { history.push({pathname: `/new_group_list`})}

    const SaveData = (e) => {
        e.preventDefault();
        setSaveFormSubmitting(true);
        const params = {
            master_id: selectedGroup?.master_id,
            asset_id: assetDetails.id,
            new_asset_matrix_code: newAssetMatrixId,
        };
        HttpAPICall.withAthorization('PUT', process.env.REACT_APP_SERVER_PATH + '/backoffice/group/asset/change_asset_matrix', access_token, {}, params, (resp) => {
            toast.success(resp.data.msg, { position: toast.POSITION.TOP_RIGHT });
            setSearchedAssetCounterLog([]);
            setAssetDetails(null);
            setNewAssetMatrixId('');
            setSaveFormSubmitting(false);
        }).then(() => {
            setSaveFormSubmitting(false);
        });



    };

    const assetMatrixJsx = () => {
        return (
            <section className="item_view_container  pageTbl ">
                <form onSubmit={SaveData} className='py-4 mx-4'>
                    <div className="row align-items-center pt-2  ">
                        <label className="col-sm-4 form-label">Asset</label>
                        <div className="col-sm-6">
                            <InputAssetSearch
                                fontSize="93%"
                                placeholder="Select Asset"
                                changeEvent={tapSelectChange}
                                isClearable={true}
                                master_id= {selectedGroup?.master_id}
                                value={searchedAssetCounterLog}
                            />
                            {loadingDetails && <Loader />}
                        </div>
                    </div>
                    {assetDetails && (
                        <div className="row align-items-center">
                            <div className="offset-4 col-sm-7">
                                <AssetMiniDetail assetDetail={[{ data: assetDetails }]} />
                            </div>
                        </div>
                    )}
                    {assetDetails && (
                        <>
                            <div className="row align-items-center py-2 ">
                                <div className="col-sm-4">
                                    <label htmlFor="name" className="form-label">Old Asset Matrix Id</label>
                                </div>
                                <div className="col-sm-6">
                                    <input
                                        name="name"
                                        type="text"
                                        value={assetDetails.asset_matrix.asset_matrix_unique_id}
                                        className="form-control"
                                        autoComplete="off"
                                        required={true}
                                        disabled
                                    />
                                </div>
                            </div>
                            <div className="row align-items-center py-2 mt-4 ">
                                <div className="col-sm-4">
                                    <label htmlFor="name" className="form-label require">New Asset Matrix Id</label>
                                </div>
                                <div className="col-sm-6">
                                    <input
                                        name="name"
                                        type="text"
                                        // value={newAssetMatrixId}
                                        onChange={(e) => setNewAssetMatrixId(e.target.value)}
                                        className="form-control"
                                        autoComplete="off"
                                        required={true}
                                        placeholder="Please enter Asset Matrix Id"
                                    />
                                </div>
                            </div>
                        </>

                    )}
                    <div className="d-flex py-2 mx-5 align-items-end justify-content-end mt-4">
                        <button
                            type="submit"
                            disabled={saveFormSubmitting || !assetDetails}
                            className="btn btn-primary"
                        >
                            Save
                            {saveFormSubmitting && (
                                <span className="ms-2">
                                    <TapIcon.FontAwesomeIcon icon={TapIcon.faSyncAlt} className="fa-spin" />
                                </span>
                            )}
                        </button>
                    </div>
                </form>
            </section>
        );
    };

    return (
        <>
            <ApplicationLayout>
                <Helmet>
                    <title>Change Asset Matrix</title>
                </Helmet>
                <div className="page_title row m0">
                    <div className='col-6'>
                        <h3>Group : {selectedGroup?.group_name} </h3>
                    </div>
                    <div className='col-6'>
                        <div className="text-end mt15 ">
                            <button type="button" className="btn btn-secondary" onClick={handleClose}  >
                                <TapIcon.imageIcon icon={TapIcon.CloseIcon} className="img-fluid" alt="item-close" />
                            </button>
                        </div>
                    </div>
                </div>
                <div className="container-fluid pl5 ">
                    <div className="page_containt row">
                        <div className="bg-white col-9 pl4" style={{ height: "100%" }}>
                            {assetMatrixJsx()}
                        </div>
                        <div className='col-3 pl4 pe-2  page_containt' style={{ top: "0px" }}>
                            <GroupCard groupListing={selectedGroup} />
                        </div>
                    </div>
                </div>

            </ApplicationLayout>
        </>
    );
};

export default ChangeAssetMatrixs;